<comp-dialog>
  <ng-container comp-dialog-header-title>{{
    'requirementIntake.details.findings.add' | translate
  }}</ng-container>
  <ng-container comp-dialog-content>
    <form id="add-finding-form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="ul-single-line-input outlined-form-element">
        <mat-label>{{ 'requirementIntake.details.findings.file' | translate }}</mat-label>
        <mat-select [formControlName]="'fileAttachmentId'" panelWidth="auto">
          @for (option of fileOptions(); track option.id) {
            <mat-option [value]="option.id">{{ option.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        [floatLabel]="'always'"
        class="ul-single-line-input outlined-form-element"
      >
        <mat-label>{{ 'model.finding.properties.name' | translate }}</mat-label>
        <input
          compAutofocus
          [formControlName]="'name'"
          matInput
          required
          [errorStateMatcher]="dirtyErrorStateMatcher"
        />
        @if (form.get('name')?.hasError('required')) {
          <mat-error>{{ 'general.validation.required' | translate }}</mat-error>
        }
        @if (form.get('name')?.hasError('maxlength')) {
          <mat-error
            >{{'general.validation.maxlength' | translate: { length:
            form.get('name')?.getError('maxlength')?.requiredLength }
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        [floatLabel]="'always'"
        class="ul-textarea-field outlined-form-element"
      >
        <mat-label>{{ 'model.finding.properties.description' | translate }}</mat-label>
        <textarea [formControlName]="'description'" matInput></textarea>
      </mat-form-field>
      <mat-form-field appearance="outline" class="ul-single-line-input outlined-form-element">
        <mat-label>{{ 'model.finding.properties.severity' | translate }}</mat-label>
        <mat-select [formControlName]="'severity'" panelWidth="auto">
          @for (severity of severityOptions(); track severity.ident) {
            <mat-option [value]="severity.ident">{{ severity.labelKey | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="ul-single-line-input outlined-form-element">
        <mat-label>{{ 'model.finding.properties.status' | translate }}</mat-label>
        <mat-select [formControlName]="'status'" panelWidth="auto">
          @for (status of statusOptions(); track status.ident) {
            <mat-option [value]="status.ident">{{ status.labelKey | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </ng-container>
  <ng-container comp-dialog-footer>
    <comp-card-buttons>
      <ng-container ngProjectAs="[right]">
        <button comp-button="secondary" type="button" (click)="onCancel()">
          {{ 'general.cancel' | translate }}
        </button>
        <button comp-button action="save" type="submit" form="add-finding-form">
          {{ 'general.save' | translate }}
        </button>
      </ng-container>
    </comp-card-buttons>
  </ng-container>
</comp-dialog>
